// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-services-chip-content[data-v-f2a78ee8]{display:inline-flex;align-items:center;gap:6px}.my-services-chip-content[data-v-f2a78ee8]>:not(.my-services-chip-content__label):not(.my-services-chip-content__dot):not(:first-child){margin-inline-start:-16px}.my-services-chip-content__label[data-v-f2a78ee8]{margin-inline-start:0}.my-services-chip-content__dot[data-v-f2a78ee8]{width:6px;height:6px;border-radius:50%;background-color:#e00;flex-shrink:0}", ""]);
// Exports
module.exports = exports;
